
// ## SINGLE MATCH

export const matchTracker = {
  matchInfo: {
    // gameID: @@ @@
    // localPlayer: null,
    // localPlayerColor: null,
    // opponent: null,
  },
  approxStartTime: null,
  moves: [],
};

export const resetMatchTracker = () => {
  matchTracker.matchInfo = {};
  matchTracker.approxStartTime = null;
  matchTracker.moves = [];
};


// ## WHOLE SESSION

export const sessionMatchesTracker = {
  lastMatch: null, // 'WON', 'LOST', 'DRAW'
  matchesAgainst: {
    // cribbio: {
    //   myVictories: 0, myDefeats: 0, myDraws: 0,
    // }
  },
  results: {
    totalVictories: 0,
    totalDefeats: 0,
    totalDraws: 0,
  },
};

export const updateSessionStats = ({ isMyVictory, isDraw, opponentName, localPlayerColor }) => {
  if (!sessionMatchesTracker.matchesAgainst[opponentName]) {
    sessionMatchesTracker.matchesAgainst[opponentName] = {
      myVictories: 0, myDefeats: 0, myDraws: 0,
    };
  }
  if (isMyVictory) {
    sessionMatchesTracker.results.totalVictories++;
    sessionMatchesTracker.matchesAgainst[opponentName].myVictories++;
  } else if (isDraw) {
    sessionMatchesTracker.results.totalDraws++;
    sessionMatchesTracker.matchesAgainst[opponentName].myDraws++;
  } else if (!isMyVictory) {
    sessionMatchesTracker.results.totalDefeats++;
    sessionMatchesTracker.matchesAgainst[opponentName].myDefeats++;
  }
  sessionMatchesTracker.lastMatchOutcome = isDraw ? 'DRAW' : (isMyVictory ? 'WON' : 'LOST');
  sessionMatchesTracker.lastMatchColor = localPlayerColor;
};
